export const CUSTOM_TIER_DESCRIPTIONS = {
  essential: 'Thoughtfully selected materials, clean lines, and a beautifully finished custom build.',
  reserve: 'Premium materials, tailored architectural details, and refined craftsmanship.',
  signature: 'Our highest expression of custom craftsmanship, combining premium materials with distinctive detailing and a more elaborate design.',
} as const;

export const CUSTOM_MATERIALS_NOTE = 'Every Bliss build uses materials and hardware selected for the design, finish, and function of each component. Your proposal outlines the specific features and finishes included.';

/** Replace obsolete stock tier copy on saved estimates; retain project-specific specifications. */
export function currentTierScopeCopy(line: string): string {
  return line
    .replace(/White maple hardwood-focused construction and detailing\./g, CUSTOM_TIER_DESCRIPTIONS.signature)
    .replace(/Birch hardwood ply frame and platforms, with birch hardwood detailing\./g, CUSTOM_TIER_DESCRIPTIONS.essential)
    .replace(/^Maple hardwood ply frame and platforms$/, CUSTOM_TIER_DESCRIPTIONS.reserve)
    .replace(/^White maple hardwood detailing$/, '')
    .replace(/Dedicated Bliss project manager\.?\s*/g, '')
    .replace(/^Preliminary layout included; full 3D renderings and dimensioned drawings with Pro Design Package purchase$/, '')
    .trim();
}
